import React, { useCallback, useState } from "react";
import { ReactifySearchProvider, Sensors, Results } from "@usereactify/search";
import { ResultItem } from "./ResultItem";
import { Filters } from "@app/components/pageCollection/Filters";
import { SortDrawerProvider } from "@app/context/SortDrawerContext";

export const Collection = ({ handle }: { handle: string }) => {
  const handleRedirect = useCallback((_: any, url: string) => {
    window.location.href = url;
  }, []);

  return (
    <ReactifySearchProvider
      mode="collection"
      includeFields={[
        "image",
        "images",
        "storefrontId",
        "handle",
        "media",
        "variants",
        "type",
        "title",
        "tags",
        "metafields",
        "product_type",
        "related",
        "id",
        "present_price_ranges",
      ]}
      excludeFields={[]}
      collectionHandle={handle}
      onRedirect={handleRedirect}
      shopifyPermanentDomain={window.Shopify.shop}
    >
      <Sensors />
      <div className="space-y-4 py-4">
        <SortDrawerProvider>
          <Filters />
        </SortDrawerProvider>
        <div className="">
          <Results
            pageSize={500}
            renderResultCardProduct={ResultItem}
            renderPaginationNumbered={() => null}
            listClassName="grid !grid-cols-2 lg:!grid-cols-3 gap-2"
          />
        </div>
      </div>
    </ReactifySearchProvider>
  );
};
